<div *ngIf="type === 'repo'" class="executed__data--repo w-100">
  <div class="d-flex mb-3">
    <label *ngIf="!executed" class="ft-18">
      {{
        adjustment.repoByInpress ? 'Weghalen aangevraagd' : 'Reeds weggehaald'
      }}
    </label>

    <label *ngIf="executed" class="ft-18">Weggehaald</label>

    <img class="marker" src="/assets/markers/Rood.png" width="22" height="32" />
  </div>

  <div
    class="executed__extra-info"
    *ngIf="
      adjustment.extraInfoAdjustment != null &&
      adjustment.extraInfoAdjustment != ''
    "
  >
    <label>Opmerkingen van de klant:</label>

    <p>{{ adjustment.extraInfoAdjustment }}</p>
  </div>

  <ng-container
    *ngIf="
      arrows != null ||
      secondBoard != null ||
      otherOrderPlacementInfo?.length > 0
    "
  >
    <ul class="inpress-ul">
      <li *ngIf="arrows != null">
        <div class="inline-table">
          <div class="strong">Pijltjes</div>

          <div *ngIf="arrows.amountArrowsLeft > 0">
            Aantal links: {{ arrows.amountArrowsLeft }}
          </div>

          <div *ngIf="arrows.amountArrowsRight > 0">
            Aantal rechts: {{ arrows.amountArrowsRight }}
          </div>
        </div>
      </li>

      <li *ngIf="secondBoard != null">
        <span class="strong">Tweede bord op hetzelfde pand</span>
      </li>

      <li *ngIf="otherOrderPlacementInfo?.length > 0">
        <div class="inline-table">
          <div class="strong">Andere bestelling</div>

          <div class="preserve-new-line">{{ otherOrderPlacementInfo }}</div>
        </div>
      </li>
    </ul>
  </ng-container>
</div>

<div *ngIf="type === 'adjustment'" class="executed__data--adjustment w-100">
  <div class="d-flex">
    <label *ngIf="!executed" class="ft-18">Aanpassing aangevraagd</label>

    <label *ngIf="executed" class="ft-18">Aanpassing uitgevoerd</label>

    <img
      class="marker"
      src="/assets/markers/Blauw.png"
      width="22"
      height="32"
    />
  </div>

  <p>{{ adjustment.extraInfoAdjustment }}</p>
</div>

<div *ngIf="type === 'soldrented'" class="executed__data--sold-rented">
  <div class="d-flex mb-3">
    <label *ngIf="adjustment.installByInpress" class="ft-18">
      <ng-container
        *ngIf="
          adjustment.signSticker?.text?.length > 0 ||
            adjustment.otherSticker?.length > 0;
          else unspecifiedSticker
        "
      >
        <span>
          "{{
            !!adjustment.signSticker
              ? adjustment.signSticker.text
              : adjustment.otherSticker
          }}"
        </span>

        <span *ngIf="executed">sticker geplaatst</span>

        <span *ngIf="!executed">sticker aangevraagd</span>
      </ng-container>

      <ng-template #unspecifiedSticker>
        <span *ngIf="executed">Sticker geplaatst</span>

        <span *ngIf="!executed">Sticker aangevraagd</span>
      </ng-template>
    </label>

    <label *ngIf="!adjustment.installByInpress">Sticker zelf aangebracht</label>

    <img class="marker" src="/assets/markers/Geel.png" width="22" height="32" />
  </div>

  <div
    class="executed__extra-info"
    *ngIf="
      adjustment.extraInfoAdjustment != null &&
      adjustment.extraInfoAdjustment != ''
    "
  >
    <label>Opmerkingen van de klant:</label>

    <p>{{ adjustment.extraInfoAdjustment }}</p>
  </div>

  <ul *ngIf="secondBoard != null" class="inpress-ul">
    <li>
      <span class="strong"> Tweede bord op hetzelfde pand </span>
    </li>
  </ul>
</div>

<ng-container *ngIf="!executed">
  <div
    class="mt-5"
    *ngIf="
      !!adjustment.projectPlacement && adjustment.projectPlacement.appointment
    "
  >
    <label>Afspraak nodig?</label>

    <p
      [class.mb-0]="adjustment.projectPlacement.needAppointmentInfo?.length > 0"
    >
      Ja
      <ng-container
        *ngIf="
          adjustment.projectPlacement.appointmentWithCustomer &&
          !!adjustment.projectPlacement.appointmentContact
        "
      >
        met makelaar (
        <span>
          &nbsp;{{
            adjustment.projectPlacement.appointmentContact.firstName
              | personName
                : adjustment.projectPlacement.appointmentContact.lastName
          }}
        </span>

        <span
          *ngIf="
            adjustment.projectPlacement.appointmentContact.phoneNumberDisplay
              ?.length > 0
          "
          class="preserve-span-space"
        >
          /
          {{
            adjustment.projectPlacement.appointmentContact.phoneNumberDisplay
          }}
        </span>

        <span
          *ngIf="
            adjustment.projectPlacement.appointmentContact.mobileNumberDisplay
              ?.length > 0
          "
          class="preserve-span-space"
        >
          /
          {{
            adjustment.projectPlacement.appointmentContact.mobileNumberDisplay
          }}
        </span>

        <span
          *ngIf="
            adjustment.projectPlacement.appointmentContact.emailDisplay
              ?.length > 0
          "
          class="preserve-span-space"
        >
          / {{ adjustment.projectPlacement.appointmentContact.emailDisplay }}
        </span>
        )
      </ng-container>

      <ng-container
        *ngIf="
          !!adjustment.projectPlacement.appointmentName ||
          !!adjustment.projectPlacement.appointmentPhoneNumber ||
          !!adjustment.projectPlacement.appointmentEmail
        "
      >
        met eigenaar/bewoner (
        <span>&nbsp;{{ adjustment.projectPlacement.appointmentName }}</span>

        <span
          *ngIf="adjustment.projectPlacement.appointmentPhoneNumber?.length > 0"
          class="preserve-span-space"
        >
          / {{ adjustment.projectPlacement.appointmentPhoneNumber }}
        </span>

        <span
          *ngIf="adjustment.projectPlacement.appointmentEmail?.length > 0"
          class="preserve-span-space"
        >
          / {{ adjustment.projectPlacement.appointmentEmail }}
        </span>
        )
      </ng-container>
    </p>

    <p *ngIf="adjustment.projectPlacement.needAppointmentInfo?.length > 0">
      {{ adjustment.projectPlacement.needAppointmentInfo }}
    </p>
  </div>

  <div class="mt-5" *ngIf="adjustment.projectPlacement.collectKey">
    <label>Sleutel afhalen?</label>

    <p>
      Ja
      <ng-container *ngIf="!!collectKeyFromCompany; else otherAdress">
        bij {{ collectKeyFromCompany.name }} -
        {{
          collectKeyFromAddress?.line1
            | printAddress
              : collectKeyFromAddress?.postalCode
              : collectKeyFromAddress?.city
        }}
      </ng-container>

      <ng-template #otherAdress>
        op ander adres: {{ adjustment.projectPlacement.collectKeyExtraInfo }}
      </ng-template>
    </p>
  </div>

  <div
    class="mt-5"
    *ngIf="
      type === 'adjustment' ||
      adjustment.repoByInpress ||
      adjustment.installByInpress
    "
  >
    <label>Wanneer uitvoeren?</label>

    <p>
      Gewenste uitvoeringsdatum:
      <ng-container *ngIf="adjustment.projectPlacement.placeASAP; else date">
        ASAP
      </ng-container>

      <ng-template #date>
        {{
          adjustment.projectPlacement.placementEarliestDate
            | date : 'dd/MM/yyyy'
        }}
      </ng-template>
    </p>
  </div>
</ng-container>
